export var ADD_RATE_COUPON = 'ADD_RATE_COUPON';
export var OPEN_BETSLIP_MODAL = 'OPEN_BETSLIP_MODAL';
export var CLOSE_BETSLIP_MODAL = 'CLOSE_BETSLIP_MODAL';
export var CLEAR_BETSLIPS = 'CLEAR_BETSLIPS';
export var DELETE_BETSLIP = 'DELETE_BETSLIP';
export var LOAD_BETSLIPS = 'LOAD_BETSLIPS';
export var CHANGE_BET_AMOUNT = 'CHANGE_BET_AMOUNT';
export var SELECT_BET_TYPE = 'SELECT_BET_TYPE';
export var ACCEPT_FACTOR_CHANGE = 'ACCEPT_FACTOR_CHANGE';
export var SAVE_BET_TYPE = 'SAVE_BET_TYPE';
export var CLEAR_CASHE_FREEBET = 'CLEAR_CASHE_FREEBET';



// WEBPACK FOOTER //
// ./src/actions/coupon/coupon.js